


































































import Component from "vue-class-component";
import BaseComponent from "../../../../../components/shared/BaseComponent.vue";
import LoadingButton from "@/components/shared/buttons/LoadingButton.vue";
import { StripeProduct } from "../../../../../app/models/subscription/StripeProduct";
import Plans from "@/components/marketing/Plans.vue";
import ErrorModal from "@/components/shared/modals/ErrorModal.vue";
import SuccessModal from "@/components/shared/modals/SuccessModal.vue";
import Stripe from "stripe";
import {
  StripePrice,
  BillingPeriod
} from "../../../../../app/models/subscription/StripePrice";

import BillingPeriodToggle from "@/components/marketing/toggles/BillingPeriodToggle.vue";
import { mapGetters } from "vuex";
@Component({
  components: {
    Plans,
    ErrorModal,
    SuccessModal,
    BillingPeriodToggle,
    LoadingButton
  },
  computed: {
    ...mapGetters("tenant", {
      stripeCard: "defaultStripeCard",
      activePrice: "activePrice",
      activeProduct: "activeProduct"
    }),
    ...mapGetters("pricing", {
      selectedPrice: "selectedPrice",
      selectedProduct: "selectedProduct"
    })
  }
})
export default class TenantSubscriptionPlan extends BaseComponent {
  private editing: boolean = false;
  private stripeCard!: Stripe.Card;
  private selectedPrice!: StripePrice;
  private activePrice!: StripePrice;
  updateSubscription() {
    if (!this.selectedPrice || !this.selectedPrice.stripeId) {
      // @ts-ignore
      this.$refs["error-modal"].show(
        this.$t("shared.select") + " " + this.$t("shared.product")
      );
      return;
    }
    if (
      this.selectedPrice.trialDays === 0 &&
      this.selectedPrice.price > 0 &&
      !this.stripeCard
    ) {
      // @ts-ignore
      this.$refs["error-modal"].show(this.$t("settings.tenant.payment.notset"));
      return;
    }

    // @ts-ignore
    this.$refs.loadingButton.start();
    this.services.stripe
      .updateSubscription(this.selectedPrice)
      .then(response => {
        this.services.stripe.getCurrentCustomer();
        // @ts-ignore
        this.$refs["success-modal"].show(
          this.$t("settings.tenant.subscription.updated")
        );
        this.eventBus.$emit("updated-plan");
        this.editing = false;
      })
      .catch(error => {
        // @ts-ignore
        this.$refs["error-modal"].show(error);
      })
      .finally(() => {
        // @ts-ignore
        this.$refs.loadingButton.stop();
      });
  }
  async openCustomerPortal() {
    this.services.stripe
      .createCustomerPortalSession()
      .then((result: any) => {
        location = result.data.url;
      })
      .catch(error => {
        // @ts-ignore
        this.$refs["error-modal"].show(error);
      });
  }
  get myProducts(): StripePrice[] {
    return (this.$store.state.tenant.myProducts as StripePrice[]).filter(
      f => f.billingPeriod !== BillingPeriod.Once
    );
  }
  get saveText() {
    if (!this.selectedPrice) {
      return this.$t("shared.select") + " " + this.$t("shared.product");
    } else if (this.selectedPrice.billingPeriod === BillingPeriod.Once) {
      return this.$t("marketing.pricing.buy");
    } else if (!this.activePrice) {
      return this.$t("marketing.pricing.subscribe");
    }
    return this.$t("shared.update");
    // else if (this.activePrice.stripeId === this.selectedPrice.stripeId) {
    //   return "";
    // } else if (this.selectedPrice.price < this.activePrice.price) {
    //   return this.$t("marketing.pricing.downgrade");
    // } else {
    //   return this.$t("shared.update");
    // }
  }
  // get selectedPrice() {
  //   const selectedProduct = this.$store.state.pricing
  //     .selectedProduct as StripeProduct;
  //   return (
  //     selectedProduct.prices.find(
  //       (f) => f.billingPeriod === this.$store.state.pricing.billingPeriod
  //     ) ?? selectedProduct.prices[0]
  //   );
  // }
}
